export default __webpack_public_path__ + "static/media/content-main-image.9b2018cd.png";